/* eslint-disable import/no-duplicates,import/prefer-default-export,object-shorthand */
/* eslint-disable no-unused-expressions,no-unused-vars,key-spacing */
// eslint-disable-next-line
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import { mapState, mapActions } from 'vuex';

export default {
  methods: {
    loadOptionsDivision({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const reqData = {
          pagination: {
            limit: 50,
            page: 1,
            column: '',
            ascending: true,
            query: searchQuery,
          },
        };
        this.$store.dispatch('jStoreFlows/getListDivisions', { reqData, callback });
      }
    },

    loadOptionsPositionByDivision({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        const reqData = {
          division_id: this.v_addApprover.organigram_id.id,
          pagination: {
            limit: 50,
            page: 1,
            column: '',
            ascending: true,
            query: searchQuery,
            query_type: 'position',
          },
        };
        this.$store.dispatch('jStoreFlows/getListByDivisions', { reqData, callback });
      }
    },

    loadOptionsPosition({ action, searchQuery, callback }) {
      let queryType;
      switch (this.filter ? this.filter : '') {
        case 'email':
          queryType = 'email';
          break;
        case 'user_name':
          queryType = 'name';
          break;
        default:
          queryType = 'position';
          break;
      }
      if (action === ASYNC_SEARCH) {
        const reqData = {
          pagination: {
            limit: 50,
            page: 1,
            column: '',
            ascending: true,
            query: searchQuery,
            query_type: queryType,
          },
        };
        this.$store.dispatch('jStoreFlows/getListPosition', { reqData, callback, label: (this.filter ? this.filter : 'name') });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/components/global/jMixPaginationOption.js